module.exports = __webpack_public_path__ + "img/owners-app.be21470b.svg";